(() => {
  if (customElements.get('opd-cart-addons')) return;
  if (!document.getElementById('OpdCartAddonStatus')) {
    const status = document.createElement('div');
    status.id = 'OpdCartAddonStatus';
    status.className = 'visually-hidden';
    status.setAttribute('role', 'status');
    status.setAttribute('aria-live', 'polite');
    document.body.append(status);
  }
  class OpdCartAddons extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.addEventListener('change', event => {
        const select = event.target.closest('[data-opd-addon-option]');
        if (!select) return;
        const card = select.closest('[data-opd-addon]');
        const button = card.querySelector('[data-opd-addon-add]');
        button.dataset.variantId = select.value;
        button.disabled = !select.value;
        card.querySelector('[data-opd-addon-price]').textContent = select.selectedOptions[0].dataset.price;
        card.querySelector('[data-opd-addon-error]').hidden = true;
      });
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-opd-addon-add]');
        if (!button || button.disabled || this.busy) return;
        this.add(button);
      });
    }
    async add(button) {
      const card = button.closest('[data-opd-addon]');
      const error = card.querySelector('[data-opd-addon-error]');
      const label = button.textContent;
      const form = this.closest('form');
      this.busy = true;
      button.disabled = true;
      button.textContent = this.dataset.adding;
      error.hidden = true;
      let response;
      try {
        response = await fetch(this.dataset.addUrl, {
          method: 'POST', credentials: 'same-origin',
          headers: {'Content-Type': 'application/json', Accept: 'application/json'},
          body: JSON.stringify({items: [{id: Number(button.dataset.variantId), quantity: 1}]})
        });
        const result = await response.json();
        if (!response.ok || result.status >= 400) {
          throw new Error(result.description || result.message || this.dataset.error);
        }
        const status = document.getElementById('OpdCartAddonStatus');
        if (status) status.textContent = this.dataset.added;
        const products = form && form.querySelector('[data-products]');
        if (products) {
          const observer = new MutationObserver(() => {
            if (this.isConnected) return;
            observer.disconnect();
            form.querySelector('[name="checkout"]')?.focus({preventScroll: true});
          });
          observer.observe(products, {childList: true});
          setTimeout(() => observer.disconnect(), 5000);
        }
        document.dispatchEvent(new CustomEvent('cart:build'));
        button.textContent = this.dataset.added;
      } catch (reason) {
        error.textContent = response && !response.ok ? reason.message : this.dataset.uncertain;
        error.hidden = false;
        button.disabled = false;
        button.textContent = label;
      } finally {
        this.busy = false;
      }
    }
  }
  customElements.define('opd-cart-addons', OpdCartAddons);
})();
